import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { map, Observable, tap } from "rxjs";
import { JwtService } from "../services/jwt.service";

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    private _jwt = inject(JwtService);

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const cloned = req.clone({
            withCredentials: true,
            headers: req.headers.set('Authorization', `Bearer ${this._jwt.raw}`),
        });
        return next.handle(cloned).pipe(
            tap(v => {
                let auth;
                if (v instanceof HttpResponse) {
                    auth = v.headers.get("authorization") ?? v.body?.jwt ?? undefined;
                }

                if (auth == null) return v;

                this._jwt.set(auth);

                return v;
            })
        );
    }
}
